import BasicValidation from 'components/components/common/BasicValidation';
import mergeErrors from 'components/helpers/mergeErrors';
import TransHelper from 'components/common/translations/TransHelper';

// Required fields of the complaint form. `license` is intentionally absent -
// it is the only optional field.
const REQUIRED_FIELDS = [
  'name',
  'email',
  'phone',
  'datetime',
  'pickup',
  'dropoff',
  'category',
  'description',
];

export default class ComplaintFormValidation extends BasicValidation {
  constructor(params, locale = "en") {
    super();
    this.params = params;
    this.locale = locale;
  }

  t = (key) => {
    return TransHelper.translate(this.locale, key);
  }

  value = (key) => {
    var value = this.params[key];
    return (value === undefined || value === null) ? '' : String(value).trim();
  }

  isPresent = (key) => {
    return !this.checkLengthIsTooShort(this.value(key), 1);
  }

  emailIsValid() {
    return this.checkIsEmail(this.value('email'));
  }

  phoneIsValid() {
    // Digits, optionally prefixed with "+", spaces / dashes / brackets allowed.
    return /^\+?[\d\s\-()]{6,20}$/.test(this.value('phone'));
  }

  descriptionIsValid() {
    return !this.checkLengthIsTooShort(this.value('description'), 20);
  }

  // Field -> error message, in the order the fields appear in the form.
  getFieldErrors() {
    var hash = {};

    REQUIRED_FIELDS.forEach((field) => {
      if (!this.isPresent(field)) {
        hash[field] = this.t('content.errors.complaint.' + field);
      }
    });

    if (!hash['email'] && !this.emailIsValid()) {
      hash['email'] = this.t('content.errors.complaint.emailInvalid');
    }
    if (!hash['phone'] && !this.phoneIsValid()) {
      hash['phone'] = this.t('content.errors.complaint.phoneInvalid');
    }
    if (!hash['description'] && !this.descriptionIsValid()) {
      hash['description'] = this.t('content.errors.complaint.descriptionTooShort');
    }

    return hash;
  }

  getFormErrors() {
    return mergeErrors(this.getFieldErrors());
  }

  isValid() {
    return Object.keys(this.getFieldErrors()).length === 0;
  }
}
